var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default_layout clearfix",attrs:{"id":"defaultLayout"}},[_c('default-header',{staticClass:"header-wrap layout-transition-up",attrs:{"id":"defaultHeader"}}),_c('div',{staticClass:"view-wrap layout-transition-fade"},[_c('router-view',{staticClass:"content-wrap"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }